import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import usePageMeta from "../../utils/usePageMeta";

const About = () => {
  usePageMeta({
    title: "About MD Wedding Props | Our Story",
    description:
      "Learn about MD Wedding Props and our passion for crafting memorable wedding decor and props.",
    keywords: "about MD Wedding Props, wedding decor company, wedding props",
  });

  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");
  useEffect(() => {
    setPrevLocation(location.state.data);
  }, [location]);
  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="About" prevLocation={prevLocation} />
      <div className="pb-10">
        <h1 className="max-w-[600px] text-base text-lightText mb-2">
          <span className="text-primeColor font-semibold text-lg">MD Wedding Props</span>{" "}
          brings your dream wedding to life with stunning decor and exquisite props. We specialize in crafting memorable experiences, providing everything from elegant arches to charming centerpieces, tailored to fit your vision of the perfect day.
          looking style.
        </h1>
        <Link to="/shop">
          <button className="w-52 h-10 bg-primeColor text-white hover:bg-black duration-300">
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
};

export default About;
